export const budgetRoutes = [
    {
        path: '/budget',
        meta: { requiresHousehold: true },
        children: [
          {
            path: '',
            component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetEntries.vue'),
          },
          {
            path: 'entries/:id',
            component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetEntryDetails.vue'),
          },
          {
            path: 'income',
            component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetIncome.vue'),
          },
          {
            path: 'accounts',
            component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetAccounts.vue'),
          },
          {
            path: 'categories',
            component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetCategories.vue'),
          },
          {
            path: 'pockets',
            children: [
              {
                path: '',
                component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetPockets.vue'),
              },
              {
                path: ':id',
                component: () => import(/* webpackChunkName: "budget" */ '@/features/budget/views/BudgetPocketDetails.vue'),
              }
            ]
          }
        ]
    }
]